export default __webpack_public_path__ + "2e5863f14f687d0c393efd8e77261ac9.svg";